module.exports = __webpack_public_path__ + "img/hangyedefen.e054b840.svg";